var React = require('react');

function FlyCartAdd (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.basketIcon{fill:none;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n"),React.createElement("path",{"className":"basketIcon","d":"M26,32.1H14c-2.2,0-4-1.8-4-4v-16h20v16C30,30.3,28.2,32.1,26,32.1z","key":1}),React.createElement("path",{"className":"basketIcon","d":"M14,17.8v-7.7c0-2.2,1.8-4,4-4h4c2.2,0,4,1.8,4,4v7.7","key":2})]);
}

FlyCartAdd.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","width":"35","height":"35","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = FlyCartAdd;

FlyCartAdd.default = FlyCartAdd;
